import { LocalStorageAdapter } from 'infra/storage-adapter/storage-adapter'

export const makeLocalStorageAdapter = (): LocalStorageAdapter =>
  new LocalStorageAdapter()
